module.exports = __webpack_public_path__ + "img/familles.7049a515.png";